import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const Heart = (props) => (
    <svg
        fill='none'
        height='26'
        viewBox='0 0 28 26'
        width='28'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M0 9C0 4.13046 3.65275 0 8.375 0C10.557 0 12.5251 0.894319 13.9998 2.33085C15.4744 0.894319 17.4425 0 19.6245 0C24.3468 0 27.9995 4.13046 27.9995 9C27.9995 10.0819 27.8215 11.1227 27.4934 12.0884C26.7793 14.432 25.3224 16.4477 23.6676 18.1963C22.0186 19.9388 20.1005 21.489 18.3956 22.867L18.3659 22.891C17.3267 23.7309 16.3751 24.5005 15.5644 25.2374C14.679 26.0422 13.3207 26.0422 12.4352 25.2374C11.6245 24.5005 10.673 23.7309 9.63378 22.891L9.60412 22.867C7.89968 21.4894 5.98235 19.9398 4.33373 18.198C2.67931 16.4502 1.22254 14.4355 0.507693 12.0931C0.17856 11.126 0 10.0837 0 9ZM8.375 2.5C5.2272 2.5 2.5 5.30912 2.5 9C2.5 9.81427 2.63505 10.5901 2.87979 11.3035L2.88716 11.325L2.89373 11.3467C3.44921 13.1801 4.62641 14.8705 6.14937 16.4795C7.67364 18.0898 9.47068 19.5447 11.2053 20.9466L11.2233 20.9612C12.1967 21.7479 13.1576 22.5246 13.9998 23.2817C14.842 22.5246 15.803 21.7479 16.7763 20.9613L16.7944 20.9466C18.5296 19.5442 20.3272 18.0889 21.8518 16.4779C23.375 14.8683 24.5522 13.1773 25.107 11.3431L25.1136 11.3214L25.1209 11.3C25.3649 10.5876 25.4995 9.81295 25.4995 9C25.4995 5.30912 22.7723 2.5 19.6245 2.5C17.7839 2.5 16.111 3.44068 15.0161 4.96992L13.9998 6.38951L12.9834 4.96992C11.8885 3.44068 10.2156 2.5 8.375 2.5Z'
            fill='currentColor'/>
    </svg>
);

export default Heart;
